import React, { useContext } from "react";
import GoalContext from "../../store/goal-context";
import classes from './SlideOver.module.scss';
const SlideOver = (props) => {
    const goalContext = useContext(GoalContext);
    return (
        <div className={`${classes['slide-over']} ${goalContext.activeGoal ? classes.active : ''}`}>{props.children}</div>
    )
}

export default SlideOver;